import { Components, Theme } from '@mui/material/styles';

export const muiIconButtonOverride: Components<Theme>['MuiIconButton'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: 4,
      color: theme.vars.palette.primary[600],
      transition: 'all 0.2s ease-in-out',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: theme.vars.palette.primary[100],
      },
      '&:active': {
        backgroundColor: theme.vars.palette.primary[100],
      },
      '&:focus-visible': {
        outlineWidth: 2,
        outlineStyle: 'solid',
        outlineColor: theme.vars.palette.primary[300],
        outlineOffset: 2,
      },
      '&.Mui-disabled': {
        backgroundColor: 'transparent',
        color: theme.vars.palette.grey[400],
      },
    }),
    sizeSmall: {
      padding: 2,
      '& > svg': {
        width: 20,
        height: 20,
      },
    },
    sizeMedium: {
      padding: 4,
      '& > svg': {
        width: 24,
        height: 24,
      },
    },
    sizeLarge: {
      padding: 6,
      '& > svg': {
        width: 24,
        height: 24,
      },
    },
  },
};
